export const JOIN_FAMILY_REQUESTED = 'JOIN_FAMILY_REQUESTED'
export const JOIN_FAMILY_CODE_VERIFY_REQUESTED =
  'JOIN_FAMILY_CODE_VERIFY_REQUESTED'
export const ONE_TIME_SMS_LOGIN_CODE_VERIFY_REQUESTED =
  'ONE_TIME_SMS_LOGIN_CODE_VERIFY_REQUESTED'
export const FAMILY_INVITE_LINK_INFO_REQUESTED =
  'FAMILY_INVITE_LINK_INFO_REQUESTED'
export const FAMILY_INVITE_LINK_FINISHED = 'FAMILY_INVITE_LINK_FINISHED'
export const FAMILY_INVITE_LINK_INFO_RECEIVED =
  'FAMILY_INVITE_LINK_INFO_RECEIVED'
export const ACCEPT_INVITE_REQUESTED = 'ACCEPT_INVITE_REQUESTED'
export const PENDING_PATIENT_LASTDIGITS = 'PENDING_PATIENT_LASTDIGITS'
export const SIGNUP_PHONENUMBER_REQUESTED = 'SIGNUP_PHONENUMBER_REQUESTED'
export const SIGNUP_PHONENUMBER_REQUESTED_SUCCESS =
  'SIGNUP_PHONENUMBER_REQUESTED_SUCCESS'
export const SIGNUP_PHONENUMBER_REQUESTED_FAILED =
  'SIGNUP_PHONENUMBER_REQUESTED_FAILED'
export const SIGNUP_PHONENUMBER_RECEIVED = 'SIGNUP_PHONENUMBER_RECEIVED'
export const SIGNUP_CODE_VERIFY_REQUESTED = 'SIGNUP_CODE_VERIFY_REQUESTED'
export const SIGNUP_CODE_VERIFY_RECEIVED = 'SIGNUP_CODE_VERIFY_RECEIVED'
export const SIGNUP_CODE_VERIFY_SUCCESS = 'SIGNUP_CODE_VERIFY_SUCCESS'
export const SIGNUP_CODE_VERIFY_FAILED = 'SIGNUP_CODE_VERIFY_FAILED'
export const SIGNUP_PHONE_NUMBER_VERIFICATION_PROCESS_COMPLETED =
  'SIGNUP_PHONE_NUMBER_VERIFICATION_PROCESS_COMPLETED'
export const SIGNUP_PANDING_PATIENT_RECEIVED = 'SIGNUP_PANDING_PATIENT_RECEIVED'
export const SIGNUP_EMAIL_REQUESTED = 'SIGNUP_EMAIL_REQUESTED'
export const SIGNUP_EMAIL_RECEIVED = 'SIGNUP_EMAIL_RECEIVED'
export const SET_SIGNUP_EMAIL = 'SET_SIGNUP_EMAIL'
export const SIGNUP_PASSWORD_REQUESTED = 'SIGNUP_PASSWORD_REQUESTED'
export const USER_ONBOARDED = 'USER_ONBOARDED'
export const EMAIL_VERIFY_REQUESTED = 'EMAIL_VERIFY_REQUESTED'
export const EMAIL_VERIFY_RECEIVED = 'EMAIL_VERIFY_RECEIVED'
export const SIGNUP_EMAIL_FAILED = 'SIGNUP_EMAIL_FAILED'
export const SIGNUP_EMAIL_SUCCESS = 'SIGNUP_EMAIL_SUCCESS'
export const SET_LOGIN_PHONE_NUMBER = 'SET_LOGIN_PHONE_NUMBER'
export const LOGIN_PHONE_NUMBER_REQUESTED = 'LOGIN_PHONE_NUMBER_REQUESTED'
export const LOGIN_PHONE_NUMBER_RECEIVED = 'LOGIN_PHONE_NUMBER_RECEIVED'
export const TEMP_BRANCH = 'TEMP_BRANCH'
export const TEMP_BRANCH_2 = 'TEMP_BRANCH_2'
export const TEMP_BRANCH_3 = 'TEMP_BRANCH_3'
export const TEMP_BRANCH_4 = 'TEMP_BRANCH_4'
export const TEMP_BRANCH_5 = 'TEMP_BRANCH_5'
export const DONT_HAVE_AN_ACCOUNT = 'DONT_HAVE_AN_ACCOUNT'
export const SSN_CODE_VERIFY_REQUESTED = 'SSN_CODE_VERIFY_REQUESTED'
export const SSN_CODE_VERIFY_RECEIVED = 'SSN_CODE_VERIFY_RECEIVED'
export const QUICK_SIGNUP_REQUESTED = 'QHICK_SIGNUP_REQUESTED'
export const QUICK_SIGNUP_RECEIVED = 'QHICK_SIGNUP_RECEIVED'
export const CLASSIFY_USER_REQUESTED = 'CLASSIFY_USER_REQUESTED'
export const CLASSIFY_USER_RECEIVED = 'CLASSIFY_USER_RECEIVED'
export const HMO_FIRST_LOGIN_FLOW = 'HMO_FIRST_LOGIN_FLOW'
export const CLASSIFY_USER_SMS_SENT_FAILED = 'CLASSIFY_USER_SMS_SENT_FAILED'
export const TELEHEALTH_SIGNUP_FLOW = 'TELEHEALTH_SIGNUP_FLOW'
export const VERIFY_SMS_FIRST_LOGIN_HMO_RECEIVED =
  'VERIFY_SMS_FIRST_LOGIN_HMO_RECEIVED'
export const VALID_SMS_RECIVED_HMO_FIRST_LOGIN =
  'VALID_SMS_RECIVED_HMO_FIRST_LOGIN'
export const VERIFY_SSN_HMO_FIRST_LOGIN_REQUESTED =
  'VERIFY_SSN_HMO_FIRST_LOGIN_REQUESTED'
export const VERIFY_SSN_HMO_FIRST_LOGIN_RECEIVED =
  'VERIFY_SSN_HMO_FIRST_LOGIN_RECEIVED'
export const VALID_SSN_RECIVED_HMO_FIRST_LOGIN =
  'VALID_SSN_RECIVED_HMO_FIRST_LOGIN'
export const SHOW_SIGNUP_ERROR_POPUP = 'SHOW_SIGNUP_ERROR_POPUP'
export const CLOSE_SIGNUP_ERROR_POPUP = 'CLOSE_SIGNUP_ERROR_POPUP'
export const GET_PREFILL_FIELDS_FOR_SIGNUP_REQUESTED =
  'GET_PREFILL_FIELDS_FOR_SIGNUP_REQUESTED'
export const GET_PREFILL_FIELDS_FOR_SIGNUP_RECEIVED =
  'GET_PREFILL_FIELDS_FOR_SIGNUP_RECEIVED'
export const GET_PREFILL_FIELDS_FOR_SIGNUP_FAILED =
  'GET_PREFILL_FIELDS_FOR_SIGNUP_FAILED'
export const PAYEMNT_REDIRECT_FLOW_USER_PROFILE_EXIST = 'PAYEMNT_REDIRECT_FLOW_USER_PROFILE_EXIST'
